

$(document).ready(function(){
  /*
  $('body').on('click','.latest_cart_product',function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
  });
  */
  console.log('running this function');
  $('body').on('click','.owl-item,.latest_cart_product',function() {
    window.location.href = $(this).find('a').attr('href');
  });
    $(".owl-carousel").owlCarousel({
      loop: true,
      margin: 30,
      center: true,
      nav: false,
      dots: false,
      stagePadding: 180,
      responsive: {
          0: {
              items: 1,
              margin: 8,
              stagePadding: 20,
              dots: true,
          },
          640: {
              items: 1,
              margin: 10,
              stagePadding: 20,
              dots: true,
          },
          768: {
              items: 1,
              margin: 15,
              stagePadding: 20,
          },
          1024: {
              items: 3,
              margin: 30,
              stagePadding: 180,
          }
      }
    });
  $('.svg-atc,.product_caet').click(function(event) {
        event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    var items = [];
    event.preventDefault();  // Prevent the default form submission action
        // Extract the variant ID from the data attribute
        var variantId = $(this).data('variant-id');
        
        // Add the variant ID to the items array if it exists
        if (variantId) {
            items.push({
                'id': variantId,
                'quantity': 1
            });
        }

    // Prepare the data object for adding all items to the cart
    var data = {
        'items': items
    };


    // Use the Shopify AJAX API to add all items to the cart
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function() {
          refreshCartDrawer();
        },
        error: function() {
            console.log('Failed to add items to the cart');
        }
    });
});

function refreshCartDrawer() {
    $.ajax({
        type: 'GET',
        url: '/cart.js', // Fetch current cart data
        dataType: 'json',
        success: function(cartData) {
            const drawerInner = document.querySelector('.drawer__inner');

            // Clear existing content inside the drawer inner
            drawerInner.innerHTML = '';

            let cartHTML = `
                <div class="drawer__header">
                    <h2 class="drawer__heading">Your cart</h2>
                    <button class="drawer__close" type="button" onclick="this.closest('cart-drawer').close()" aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                            <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
                        </svg>
                    </button>
                </div>
                <cart-drawer-items>
                    <form action="/cart" id="CartDrawer-Form" class="cart__contents cart-drawer__form" method="post">
                        <div id="CartDrawer-CartItems" class="drawer__contents js-contents">
                            <div class="drawer__cart-items-wrapper">
                                <table class="cart-items" role="table">
                                    <thead role="rowgroup">
                                        <tr role="row">
                                            <th id="CartDrawer-ColumnProductImage" role="columnheader">
                                                <span class="visually-hidden">Product image</span>
                                            </th>
                                            <th id="CartDrawer-ColumnProduct" class="caption-with-letter-spacing" scope="col" role="columnheader">
                                                Product
                                            </th>
                                            <th id="CartDrawer-ColumnTotal" class="right caption-with-letter-spacing" scope="col" role="columnheader">
                                                Total
                                            </th>
                                            <th id="CartDrawer-ColumnQuantity" role="columnheader">
                                                <span class="visually-hidden">Quantity</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody role="rowgroup">
            `;

            if (cartData.items.length > 0) {
                cartData.items.forEach((item, index) => {
                    const hasDiscount = item.original_price > item.final_price;
                    const discountTitle = item.discounts.length > 0 ? item.discounts[0].title : '';

                    cartHTML += `
                    <tr id="CartDrawer-Item-${index + 1}" class="cart-item" role="row">
                        <td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage">
                            <a href="${item.url}" class="cart-item__link" tabindex="-1" aria-hidden="true"></a>
                            <img class="cart-item__image" src="${item.image}" alt="${item.title}" loading="lazy" width="150" height="150">
                        </td>
                        <td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct">
                            <a href="${item.url}" class="cart-item__name h4 break">${item.title}</a>
                            <div class="cart-item__discounted-prices">
                                ${hasDiscount ? `
                                <span class="visually-hidden">Regular price</span>
                                <s class="cart-item__old-price product-option">$${(item.original_price / 100).toFixed(2)}</s>
                                <span class="visually-hidden">Sale price</span>
                                <strong class="cart-item__final-price product-option">$${(item.final_price / 100).toFixed(2)}</strong>
                                ` : `
                                <strong class="cart-item__final-price product-option">$${(item.original_price / 100).toFixed(2)}</strong>
                                `}
                            </div>
                            <ul class="discounts list-unstyled" role="list" aria-label="Discount">
                                ${discountTitle ? `
                                    <li class="discounts__discount">
                                        <svg aria-hidden="true" focusable="false" class="icon icon-discount" viewBox="0 0 12 12">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
                                        </svg>
                                        ${discountTitle}
                                    </li>
                                ` : ''}
                            </ul>
                        </td>
                        <td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal">
                            <div class="loading__spinner hidden">
                                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                </svg>
                            </div>
                            <div class="cart-item__price-wrapper">
                                ${hasDiscount ? `
                                <div class="cart-item__discounted-prices">
                                    <span class="visually-hidden">Regular price</span>
                                    <s class="cart-item__old-price price price--end">$${(item.original_price / 100).toFixed(2)}</s>
                                    <span class="visually-hidden">Sale price</span>
                                    <span class="price price--end">$${(item.final_price / 100).toFixed(2)}</span>
                                </div>
                                ` : `
                                <div class="cart-item__price-wrapper">
                                    <span class="price price--end">$${(item.original_price / 100).toFixed(2)}</span>
                                </div>
                                `}
                            </div>
                        </td>
                        <td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity">
                            <quantity-popover>
                                <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
                                    <div class="quantity-popover-container">
                                        <quantity-input class="quantity cart-quantity">
                                            <button class="quantity__button" name="minus" type="button">
                                                <span class="visually-hidden">Decrease quantity for ${item.title}</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                                                </svg>
                                            </button>
                                            <input class="quantity__input" type="number" data-quantity-variant-id="${item.id}" name="updates[]" value="${item.quantity}" min="0" data-min="1" step="1" aria-label="Quantity for ${item.title}" id="Drawer-quantity-${index + 1}" data-index="${index + 1}">
                                            <button class="quantity__button" name="plus" type="button">
                                                <span class="visually-hidden">Increase quantity for ${item.title}</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                                                </svg>
                                            </button>
                                        </quantity-input>
                                    </div>
                                    <cart-remove-button id="CartDrawer-Remove-${index + 1}" data-index="${index + 1}">
                                        <button type="button" class="button button--tertiary cart-remove-button" aria-label="Remove ${item.title}" data-variant-id="${item.id}">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
                                                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                                                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                                            </svg>
                                        </button>
                                    </cart-remove-button>
                                </div>
                                <div id="CartDrawer-LineItemError-${index + 1}" class="cart-item__error" role="alert">
                                    <small class="cart-item__error-text"></small>
                                    <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                                        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                                        <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                                        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                                    </svg>
                                </div>
                            </quantity-popover>
                        </td>
                    </tr>
                    `;
                });
            } else {
                cartHTML += `
                <tr>
                    <td colspan="4" class="text-center">Your cart is currently empty.</td>
                </tr>
                `;
            }

            cartHTML += `
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <p id="CartDrawer-LineItemStatus" class="visually-hidden" aria-hidden="true" role="status">Loading...</p>
                        <div id="CartDrawer-CartErrors" role="alert"></div>
                    </form>
                </cart-drawer-items>
                <div class="drawer__footer">
                    <div class="cart-drawer__footer">
                        <div class="totals" role="status">
                            <h2 class="totals__total">Estimated total</h2>
                            <p class="totals__total-value">$${(cartData.total_price / 100).toFixed(2)} USD</p>
                        </div>
                        <small class="tax-note caption-large rte">Taxes, discounts, and <a href="/policies/shipping-policy">shipping</a> calculated at checkout.</small>
                        <div class="cart__ctas">
                            <button type="submit" id="CartDrawer-Checkout" class="cart__checkout-button button" name="checkout" form="CartDrawer-Form">
                                Check out
                            </button>
                        </div>
                    </div>
                </div>
            `;

            // Insert the new HTML content
            drawerInner.innerHTML = cartHTML;
          $('.drawer.is-empty').removeClass('is-empty');
          $('.drawer').addClass('active');
          updateCartIcon(cartData.item_count); 
        }
    });
}
function updateCartIcon(cartItemCount) {
    // Find the existing cart icon element
    const cartIcon = document.querySelector('.header__icon--cart');

    // Remove existing contents if any
    cartIcon.innerHTML = '';

    // Create the SVG element
    const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svgElement.setAttribute('width', '25');
    svgElement.setAttribute('height', '24');
    svgElement.setAttribute('viewBox', '0 0 25 24');
    svgElement.setAttribute('fill', 'none');

    // Create the path inside the SVG
    const svgPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    svgPath.setAttribute('fill', 'black');
    svgPath.setAttribute(
        'd',
        'M3.36914 2.25C2.95493 2.25 2.61914 2.58579 2.61914 3C2.61914 3.41421 2.95493 3.75 3.36914 3.75L3.36914 2.25ZM5.86914 3L6.59675 2.8181C6.51328 2.48422 6.21329 2.25 5.86914 2.25V3ZM19.3691 16.75C19.7834 16.75 20.1191 16.4142 20.1191 16C20.1191 15.5858 19.7834 15.25 19.3691 15.25V16.75ZM21.3691 5L22.0967 5.1819C22.1528 4.95785 22.1024 4.72048 21.9603 4.53844C21.8182 4.3564 21.6001 4.25 21.3691 4.25V5ZM19.3691 13V13.75C19.7133 13.75 20.0133 13.5158 20.0967 13.1819L19.3691 13ZM3.36914 3.75H5.86914V2.25H3.36914L3.36914 3.75ZM5.14153 3.1819L5.64153 5.1819L7.09675 4.8181L6.59675 2.8181L5.14153 3.1819ZM5.64153 5.1819L7.64153 13.1819L9.09675 12.8181L7.09675 4.8181L5.64153 5.1819ZM8.36914 12.25H7.86914V13.75H8.36914V12.25ZM7.86914 16.75H19.3691V15.25H7.86914V16.75ZM5.61914 14.5C5.61914 15.7426 6.6265 16.75 7.86914 16.75V15.25C7.45493 15.25 7.11914 14.9142 7.11914 14.5H5.61914ZM7.86914 12.25C6.6265 12.25 5.61914 13.2574 5.61914 14.5H7.11914C7.11914 14.0858 7.45493 13.75 7.86914 13.75V12.25ZM6.36914 5.75H21.3691V4.25H6.36914V5.75ZM20.6415 4.8181L18.6415 12.8181L20.0967 13.1819L22.0967 5.1819L20.6415 4.8181ZM19.3691 12.25H8.36914V13.75H19.3691V12.25ZM18.6191 20C18.6191 20.1381 18.5072 20.25 18.3691 20.25V21.75C19.3356 21.75 20.1191 20.9665 20.1191 20H18.6191ZM18.3691 20.25C18.2311 20.25 18.1191 20.1381 18.1191 20H16.6191C16.6191 20.9665 17.4026 21.75 18.3691 21.75V20.25ZM18.1191 20C18.1191 19.8619 18.2311 19.75 18.3691 19.75V18.25C17.4026 18.25 16.6191 19.0335 16.6191 20H18.1191ZM18.3691 19.75C18.5072 19.75 18.6191 19.8619 18.6191 20H20.1191C20.1191 19.0335 19.3356 18.25 18.3691 18.25V19.75ZM8.61914 20C8.61914 20.1381 8.50721 20.25 8.36914 20.25V21.75C9.33564 21.75 10.1191 20.9665 10.1191 20H8.61914ZM8.36914 20.25C8.23107 20.25 8.11914 20.1381 8.11914 20H6.61914C6.61914 20.9665 7.40264 21.75 8.36914 21.75V20.25ZM8.11914 20C8.11914 19.8619 8.23107 19.75 8.36914 19.75V18.25C7.40264 18.25 6.61914 19.0335 6.61914 20H8.11914ZM8.36914 19.75C8.50721 19.75 8.61914 19.8619 8.61914 20H10.1191C10.1191 19.0335 9.33564 18.25 8.36914 18.25V19.75Z'
    );
    svgElement.appendChild(svgPath);

    // Append the SVG to the cart icon
    cartIcon.appendChild(svgElement);

    // Create the cart count bubble if there are items in the cart
    if (cartItemCount > 0) {
        const cartCountBubble = document.createElement('div');
        cartCountBubble.className = 'cart-count-bubble';

        cartCountBubble.innerHTML = `
            <span aria-hidden="true">${cartItemCount}</span>
            <span class="visually-hidden">${cartItemCount} items</span>
        `;

        // Append the cart count bubble to the cart icon
        cartIcon.appendChild(cartCountBubble);
    }

    // Finally, append the cart icon to the parent container (header)
    header.appendChild(cartIcon);
}
  });
  



